import React from 'react'
import Page from "../Page";
import LoadingBanner from "../../components/LoadingBanner";
import OppBriefStep from "./OppBriefStep";
import Form from "../../components/form/Form";
import ReactDOM from "react-dom";
import DocumentRow from "../../components/DocumentRow";
import Opportunity from "../../models/Opportunity";
import MultiFileUpload from "../../components/form/MultiFileUpload";
import OppDashboard from "./OppDashboard";
import {useLocation, useNavigate} from "react-router-dom";
import {useOpportunity} from "../../providers/OpportunityProvider";
import PageNotAllowed from '../../components/errors/PageNotAllowed';

export default class OppContractStep extends Page {

    static path = '/sign-contract';

    static title = 'Contract';

    static badgeForOpp(opportunity) {
        if(opportunity.isAccepted() && opportunity.isPendingContract() && opportunity.hasContract() && !opportunity.hasSignedContract()) {
            return (
                <i className="fas text-danger fa-exclamation-circle"/>
            )
        }
        return null
    }

    static isLocked(opportunity) {

        return !opportunity.detailedViewAvailable() || !opportunity.isAccepted() ||
            opportunity.isAwaitingTeamApproval() ||
            opportunity.isProposing()
    }
    static accomplishedForOpportunity(opportunity) {
        return opportunity.hasSignedContract()
    }

    constructor(props) {
        super(props);

        this.formRef = React.createRef();

        this.state = {
            ...this.state,
            isLoading: true,
            formModel: {
                confirm_signature: null
            }
        }
    }
    componentDidMount()
    {
        super.componentDidMount();
        this.middlewareCheck(() => this.promisedState({isLoading: false}))
    }

    validateProjectMiddleware()
    {
        let opportunity = this.props.opportunity;

        if (!opportunity.isAccepted()){
            return {
                key: 'talent.opportunity_prompt_needs_accept_brief',
                redirect: OppBriefStep
            };
        }else if(opportunity.isAwaitingTeamApproval()) {
            return {
                key: 'talent.opportunity_prompt_awaiting_team_approval',
                redirect: OppBriefStep
            };
        }else if (opportunity.isProposing()) {
            return {
                key: 'talent.opportunity_prompt_proposal_in_progress',
                redirect: OppDashboard,
            };
        }
    }

    async middlewareCheck(callback = () => {})
    {
        if (this.context.auth?.isTalentSupplierResource()) {
            return;
        }
        let error = this.validateProjectMiddleware();

        if (!error) {
            return callback();
        }

        await TB.sysAlert(error.key);

        return this.props.navigate('..' + error.redirect.path, {replace: true});
    }

    validateSignature() {
        if (!this.formRef.current) {
            return false
        }
        let invalid = this.formRef.current.forceValidate();

        if(invalid) {
            const node = ReactDOM.findDOMNode(invalid);

            $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
        }
        return !invalid;
    }

    async signContract()
    {

        if (this.props.opportunity.latest_signed_contract) {

            let success = await this.props.onUpdate({
                signed_contract_at: new Date()
            });

            if (success) {
                await TB.sysAlert('talent.opportunity_active');
            }
        }

    }

    async deleteDocument(doc) {
        let confirmDelete = await TB.sysAlert("talent.delete_proposal_slide_button_clicked");


        if (confirmDelete) {
            await this.promisedState({isDisabled: true})
            let success = await this.props.opportunity.deleteDocument(doc, 'latest_signed_contract');

            if (success) {
                await TB.wait(100);
                await this.promisedState({isDisabled: false})
            }
        }
    }

    signatureFormFields() {

        let fields = [
            {
                fields: {
                    contractInfo: {
                        component: (
                            <div>
                                <h3>My Signed Contract</h3>
                                <p>
                                    Please upload your signed contract below. Once finalized, the fully executed contract will appear in your contract repository.
                                </p>
                            </div>
                        )
                    }
                }
            }];

        if (this.props.opportunity.latest_signed_contract) {
            fields.push({
                fields: {
                    previous_signed_contract: {
                        component: this.props.opportunity.latest_signed_contract ? (
                            <div className='talent-documents-container'>

                                <DocumentRow
                                    document={this.props.opportunity.latest_signed_contract}
                                    onDelete={this.props.opportunity.isPendingContract() ? () => this.deleteDocument(this.props.opportunity.latest_signed_contract) : undefined}
                                    onUpdate={this.props.opportunity.isPendingContract() ? this.onFileChange.bind(this) : undefined}
                                    disabled={this.props.isDisabled}
                                />
                            </div>
                        ) : null,
                        required: false,
                        label: false,
                        style: {margin: '0 auto'},
                        columns: 12
                    },
                }
            })
        }else {
            fields.push({
                fields:{
                    latest_signed_contract: {
                        component: this.renderUploadForm(),
                        required: true,
                        label: false,
                        style: {margin: '0 auto'},
                        columns: 4
                    }
                }
            })
        }

        return fields;
    }

    async onFileUploaded(response, file) {

        if (!TB.has(response, 'success.data.document')) {
            return;
        }

        let opportunity = {...this.props.opportunity};

        opportunity.latest_signed_contract = {...response.success.data.document};

        if (file.remove) {
            file.remove();
        }

        TB.event('Opportunities@updated', Opportunity.make({...opportunity}))
    }

    async onFileChange(path) {

        let FileChangeRequest = TB.request(`/api/talent-user-opportunities/${this.props.opportunity.id}/documents/create`, {
            name: path.name,
            path,
            type: TB.invert(laravel.document_types)['Talent Signed Contract']
        });

        FileChangeRequest = FileChangeRequest.headers({
            'Content-Type': 'multipart/form-data'
        })
        let response = await FileChangeRequest.post().catch(console.warn);

        await this.onFileUploaded(response, path);

        await TB.sysAlert('talent.opp_uploaded_signed_contract_success');
    }

    renderUploadForm() {
        let opp = this.props.opportunity;

        return (
            <MultiFileUpload
                multiple={false}
                uploadParams={{
                    url:  `/api/talent-user-opportunities/${opp.id}/documents/create`,
                    fields: {
                        type: TB.invert(laravel.document_types)['Talent Signed Contract']
                    }
                }}
                onFileUploaded={this.onFileUploaded.bind(this)}
            />
        )
    }

    renderTalentContractSection()
    {
        let {
            opportunity,
            isDisabled
        } = this.props;

        return (
            <div className="talent-opp-contract-container">
                <Form
                    ref={this.formRef}
                    className="talent-opp-contract-form"
                    onSubmit={console.warn}
                    submitButton={false}
                    isDisabled={isDisabled}
                    model={this.state.formModel}
                    onChange={formModel => this.promisedState({formModel})}
                    fields={this.signatureFormFields()}/>

                    <div className="talent-opp-contract-btns">
                        <button
                            type="button"
                            disabled={isDisabled || (!
                                    this.props.opportunity.latest_signed_contract
                                && !this.state.formModel.contract_upload
                            )}
                            onClick={this.signContract.bind(this)}
                            className="btn btn-primary mr-2">
                            Finish
                        </button>

                    </div>
            </div>
        );
    }

    render() {
        if (this.context.auth?.isTalentSupplierResource()) {
            return <PageNotAllowed redirect="/talent/dashboard" />
        }

        let {
            opportunity
        } = this.props;
        let {
            isLoading
        } = this.state;


        return (
            <div className='talent-portal-container'>
                <div className='talent-portal-page-container talent-opportunity-container'>
                    <div className="talent-opp-wizard-header pt-6">

                        <h2>Contract</h2>

                    </div>

                    {isLoading ? (
                        <LoadingBanner message="Loading Contract"/>
                    ) : (
                        <div className="talent-project-contracts-panel mx-3 mb-6">
                            <div className="panel-header">
                                Signatures
                            </div>
                            <div className='talent-project-proposal-container'>
                                <div className="proposal-document-header">
                                    <p>
                                        Your Contract
                                    </p>
                                </div>

                                <DocumentRow
                                    document={opportunity.latestContract()}
                                    type="PDF"
                                    emptyMessage={"No Contract Yet"}
                                />

                            </div>

                            {opportunity.hasContract() &&
                                (opportunity.hasSignedContract() ? (
                                            <React.Fragment>
                                                <div>
                                                    <h3>My Signed Contract</h3>
                                                </div>
                                                <div className='talent-documents-container'>

                                                    <DocumentRow
                                                        document={this.props.opportunity.latest_signed_contract}
                                                        onDelete={this.props.opportunity.isPendingContract() ? () => this.deleteDocument(this.props.opportunity.latest_signed_contract) : undefined}
                                                        onUpdate={this.props.opportunity.isPendingContract() ? this.onFileChange.bind(this) : undefined}
                                                        disabled={this.props.isDisabled}
                                                    />
                                                </div>
                                            </React.Fragment>
                                        ) :
                                    this.renderTalentContractSection()
                                )
                            }
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const OppContractTab = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        onRequest,
        onUpdate,
        opportunity,
        isDisabled
    } = useOpportunity()

    return (
        <OppContractStep location={location} navigate={navigate} onRequest={onRequest}
                      onUpdate={onUpdate}
                      opportunity={opportunity}
                      isDisabled={isDisabled}/>
    )
}

export {
    OppContractTab
}